<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Loja Parceira</span>
        <h3 class="page-title d-inline">Editar</h3>
        <router-link class="btn btn-success text-white float-right" :to="{ name: 'admin-reseller-new' }">Nova loja</router-link>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <reseller-page ref="resellerForm"/>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import ResellerPage from '_modules/reseller/components/ResellerPage.vue';

export default {
  name: 'reseller-edit',
  components: {
    ResellerPage,
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'checkAdmin',
      'activeAlert',
      'getReseller',
    ]),
    getResellerModel(id) {
      this.setToggle({ type: 'progress', bool: true });
      this.getReseller(id)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        })
        .catch(error => {
          this.activeAlert({ message: error, theme: 'danger' });
        });
    },
  },
  mounted() {
    this.checkAdmin();
    if (this.$route.params.resellerId) {
      return this.getResellerModel(parseInt(this.$route.params.resellerId, Number));
    }
    return this.getResellerModel(null);
  },
};
</script>
